module.exports = __webpack_public_path__ + "static/media/corga2.985668f6.svg";